import React from "react";
import { Award, Gift, Crown, Star } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const TIERS = [
  { name: "Standard", min: 0, perks: ["Free shipping", "Newsletter"] },
  { name: "Gold", min: 500, perks: ["Early drops", "Birthday gift", "Concierge access"] },
  { name: "Atelier", min: 2500, perks: ["VIP drops", "Personal stylist", "Private appointments"] },
  { name: "Founder", min: 10000, perks: ["Legacy invitation", "Engraving included", "Founder dinner"] },
];

export default function AppLoyalty() {
  const { user } = useAuth();
  const points = user?.loyalty_points || 0;
  const currentTier = TIERS.slice().reverse().find(t => points >= t.min) || TIERS[0];
  const next = TIERS.find(t => t.min > points);
  const progress = next ? Math.min(100, ((points - currentTier.min) / (next.min - currentTier.min)) * 100) : 100;

  return (
    <div data-testid="app-loyalty" className="pb-6">
      <header className="px-5 pt-12">
        <div className="text-[11px] tracking-luxury uppercase text-poche-gold">Loyalty</div>
        <h1 className="font-serif text-2xl mt-1">POCHE Atelier Status</h1>
      </header>

      <div className="mx-5 mt-4 bg-poche-gold text-poche-black p-5">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-[10px] tracking-luxury uppercase">Current Tier</div>
            <div className="font-serif text-3xl">{currentTier.name}</div>
          </div>
          <Crown size={28} strokeWidth={1.4} />
        </div>
        <div className="mt-4">
          <div className="text-[10px] tracking-luxury uppercase">{points.toLocaleString()} Points</div>
          <div className="h-1 bg-black/15 mt-2">
            <div className="h-full bg-poche-black" style={{ width: `${progress}%` }} />
          </div>
          {next && <div className="text-[10px] tracking-luxury uppercase mt-2">{(next.min - points).toLocaleString()} pts to {next.name}</div>}
        </div>
      </div>

      <div className="px-5 mt-6">
        <div className="text-[10px] tracking-luxury uppercase text-white/45 mb-2">Tier Perks</div>
        <div className="space-y-3">
          {TIERS.map((t) => (
            <div key={t.name} className={`border p-4 ${t.name === currentTier.name ? "border-poche-gold bg-poche-gold/5" : "border-white/10"}`}>
              <div className="flex items-center justify-between">
                <div className="font-serif text-lg">{t.name}</div>
                <div className="text-[10px] tracking-luxury uppercase text-white/55">{t.min}+ pts</div>
              </div>
              <ul className="text-xs text-white/65 mt-2 space-y-1">
                {t.perks.map(p => <li key={p}>· {p}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="px-5 mt-6 grid grid-cols-2 gap-3">
        <div className="bg-poche-ink p-4 border border-white/10">
          <Gift size={18} className="text-poche-gold" strokeWidth={1.4} />
          <div className="font-serif text-base mt-2">Birthday Gift</div>
          <div className="text-[10px] tracking-luxury uppercase text-white/45 mt-1">Unlocks at Gold</div>
        </div>
        <div className="bg-poche-ink p-4 border border-white/10">
          <Star size={18} className="text-poche-gold" strokeWidth={1.4} />
          <div className="font-serif text-base mt-2">VIP Drops</div>
          <div className="text-[10px] tracking-luxury uppercase text-white/45 mt-1">Atelier members only</div>
        </div>
      </div>
    </div>
  );
}
